export default function dataStatistics(name, action, category) {
  window.taotieCommandQueue = window.taotieCommandQueue || []
  let parameterObject = {}
  parameterObject.name = name 
  parameterObject.action = action //事件操作
  parameterObject.category = category //事件种类或者叫事件类别

  
  // parameterObject.name='Lean'; //事件标签 可选字段 字符串类型
  // parameterObject.value=1; //事件价值 可选字段 数值类型
  taotieCommandQueue.push({
    command: 'sendEventlogMessageToKafka',
    parameter: parameterObject
  })
}



// WEBPACK FOOTER //
// ./src/assets/js/dataStatistics.js